export default () => {
  return {
    step: '',
    fields: {
      email: '',
      extras: [],
    },
  }
}
